import React from "react";
import {ImageDiv} from "./widgets/Styled";
import PropTypes from "prop-types";
import VisibilitySensor from "react-visibility-sensor";
import {validateField} from "../../../utils/validation";

class ImageEntity extends React.Component {
    constructor(props) {
        super(props);
        this.image = null;
        let currentImage = props.src;
        let defaultBase64Image = props.isDefaultWhite
            ? "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMxaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0NSA3OS4xNjM0OTksIDIwMTgvMDgvMTMtMTY6NDA6MjIgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkZGOEIxRTQyMjc4RTExRTk5QTI1RkEyQjkzMjE1QUQ5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkZGOEIxRTQzMjc4RTExRTk5QTI1RkEyQjkzMjE1QUQ5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjE1Mzk4N0YyNzdFMTFFOTlBMjVGQTJCOTMyMTVBRDkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MjE1Mzk4ODAyNzdFMTFFOTlBMjVGQTJCOTMyMTVBRDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgIDAwMDAwMDAwMDAQEBAQEBAQIBAQICAgECAgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwP/wAARCAABAAEDAREAAhEBAxEB/8QASgABAAAAAAAAAAAAAAAAAAAACgEBAAAAAAAAAAAAAAAAAAAAABABAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AfwD/2Q=="
            : props.loaderImage
            ? props.loaderImage
            : "data:image/gif;base64,R0lGODlhAQABAPAAAMzMzAAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
        if (props.isLazy) {
            currentImage = defaultBase64Image;
        }
        this.state = {
            image: currentImage,
            isVisible: !props.isLazy,
            loading: true,
        };
        this.defaultImage = defaultBase64Image;
        this.fallBackChecked = false;
    }

    componentDidMount() {
        // const {debug} = this.props;
        // if(debug)
        //     console.log('mount');
        const {isLazy, fallbackURL} = this.props;
        const {image} = this.state;
        if (!isLazy && validateField(fallbackURL)) {
            this.loadImage(image);
        }
    }

    componentDidUpdate(oldProps) {
        const {src, isLazy} = this.props;
        if (src !== oldProps.src) {
            this.fallBackChecked = false;
            let stateObj = {};
            if (!isLazy) {
                stateObj["image"] = src;
            }
            if (this.state.isVisible) {
                this.loadImage(src);
            } else {
                stateObj = {loading: true};
            }
            this.setState(stateObj);
        }
    }

    componentWillUnmount() {
        if (this.image) {
            this.image.onload = null;
            this.image.onerror = null;
        }
    }

    loadImage = (src) => {
        // const {debug} = this.props;
        // if(debug)
        //     console.log('load');
        if (this.image) {
            this.image.onload = null;
            this.image.onerror = null;
        }
        const image = new Image();
        this.image = image;
        image.onload = this.onLoad;
        image.onerror = this.onError;
        image.src = src;
    };

    onLoad = () => {
        this.setState({
            image: this.image.src,
            loading: false,
        });
    };

    onError = (errorEvent) => {
        const {onError, fallbackURL, isLazy} = this.props;
        this.setState({
            loading: false,
        });
        if (validateField(fallbackURL) && !this.fallBackChecked) {
            this.fallBackChecked = true;
            this.loadImage(fallbackURL);
        } else {
            if (!isLazy) {
                this.setState({image: this.defaultImage});
            }
            if (onError) {
                onError(errorEvent);
            }
        }
    };

    onShow = (isVisible) => {
        this.setState(
            {
                isVisible: isVisible,
            },
            () => {
                if (this.state.loading && this.state.isVisible) {
                    this.loadImage(this.props.src);
                }
            },
        );
    };

    renderImage = () => {
        let jsx = null;
        // eslint-disable-next-line no-unused-vars
        const {isLazy, intervalCheck, src, debug, ...restProps} = this.props;
        const {loading, image} = this.state;
        if (debug) console.log({state: this.state, props: this.props});
        if (isLazy) {
            jsx = (
                <VisibilitySensor
                    onChange={this.onShow}
                    partialVisibility={true}
                    active={loading}
                    intervalCheck={intervalCheck}
                    intervalDelay={500}
                    scrollCheck={true}
                    scrollThrottle={100}
                >
                    <ImageDiv src={image} {...restProps} />
                </VisibilitySensor>
            );
        } else {
            jsx = <ImageDiv src={image} {...restProps} />;
        }
        return jsx;
    };

    render() {
        return this.renderImage();
    }
}
ImageEntity.propTypes = {
    onError: PropTypes.func,
    src: PropTypes.string.isRequired,
    isLazy: PropTypes.bool,
    alt: PropTypes.string.isRequired,
    intervalCheck: PropTypes.bool,
    isDefaultWhite: PropTypes.bool,
    fallbackURL: PropTypes.string,
    loaderImage: PropTypes.string,
    debug: PropTypes.bool,
};
ImageEntity.defaultProps = {
    isLazy: false,
    intervalCheck: false,
    isDefaultWhite: false,
    debug: false,
};
export default ImageEntity;
